import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls/Card";
import { baseURLV1, baseURL } from "../../../service/API.js";
import { useSubheader } from "../../../../_metronic/layout";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import xlsxFile from "read-excel-file";

import { Link } from "react-router-dom";


export const ImportMasterMainten = () => {
  const { user, authToken } = useSelector((state) => state.auth);
  const suhbeader = useSubheader();
  suhbeader.setTitle("Import Master Maintenance");

  const [state, setState] = useState({
    imageId: null,
    imageName: "",
    imageURL: "",
  });
  const [isUpload, setIsUpload] = useState(false);
  const [progress, setProgress] = useState(0);

  const AlertError = (message) => {
    Swal.fire("Upload Master Maintenance!", message, "error");
  };


  const handleChangeFile = async (e) => {
    let check_error = false;
    setIsUpload(true);
    setProgress(25);
    if (e.target.files.length) {
      e.preventDefault();
      let file = e.target.files[0];
      var reader = new FileReader();

      reader.readAsDataURL(file);
      let data_all = [];
      await xlsxFile(file).then(async (rows) => {
        setProgress(100);

        if (rows[0][1] !== "model_id") {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("Error, wrong column name!!");
        }

        if (rows[0][2] !== "model") {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("Error, wrong column name!!");

        }


        if (rows[0][3] !== "master_value") {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("Error, wrong column name!!");
        }

        
        if (rows[0][4] !== "region") {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("Error, wrong column name!!");
        }

        if (rows[0][5] !== "value") {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("Error, wrong column name!!");
        }

        await rows.map((data, i) => {
          if (i !== 0) {
            let mainten = {
              model_id: data[1],
              model: data[2],
              master_value: data[3],
              region: data[4],
              value: data[5],
            };
            data_all.push(mainten)
          }
        })

      });


      await data_all.map((data, i) => {
        if (!data.model_id) {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("model id error !!");
        }

        if (!data.model) {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("model error !!");
        }

        if (!data.master_value) {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("master value error !!");
        }

        if (!data.region) {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("region error !!");
        }

      
        if (!data.value) {
          setProgress(0);
          setIsUpload(false);
          check_error = true
          return AlertError("value error !!");
        }
      })

      if (!check_error) {
        var formdata = new FormData();
        formdata.append("file", file, file.name);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${baseURLV1}/mainten/import`, requestOptions)
          .then(response => response.text())
          .then(result => {
            Swal.fire("Updated !", "You can update status. !! ");
          })
          .catch(error => {
            if (error.response) {
              Swal.fire(
                "Updated !",
                "You can not update status. !! ",
                "error"
              );
            }
          });
      }
    }
  };

  return (
    <Card>
      <CardHeader title="Import Master Maintenance"></CardHeader>
      <CardBody>
        <>
          <form>
            <div
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
              }}
            ></div>
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                Upload file: <br></br>
              </p>
              <input
                name="ImageURL"
                style={{
                  height: "38px",
                  width: "330px",
                  backgroundColor: "#F4F6F9",
                  borderRadius: "5px",
                  borderWidth: "0",
                }}
                disabled
                value={state.imageURL}

              />

              <span className="btn btn-primary btn-file wbt">
                Select File
                <input type="file" onChange={handleChangeFile} />
              </span>
            </div>
            {isUpload ? (
              <div>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {progress}
                  </div>
                </div>
              </div>
            ) : null}

          </form>
          <Link to="/files/master_mainten.xlsx" target="_blank" download>
            <button className="btn btn-primary mt-3">
            Download Excel Template
            </button>
          </Link>
        </>
      </CardBody>
    </Card>
  );
};
